var a = /* @__PURE__ */ ((e) => (e.Request = "request", e.Examples = "examples", e.Cookies = "cookies", e.Collection = "collection", e.Schema = "schema", e.Environment = "environment", e.Servers = "servers", e.Workspace = "workspace", e.Settings = "settings", e))(a || {});
const o = "activeWorkspace";
function s(e) {
  const t = e.params.workspace;
  t && localStorage.setItem(o, `${t}`);
}
function n() {
  const e = localStorage.getItem(o);
  return e ? {
    name: "request.root",
    params: {
      workspace: e
    }
  } : {
    name: "workspace.default"
  };
}
const r = [
  {
    name: "request.root",
    path: "",
    component: () => import("./views/Request/RequestRoot.vue.js"),
    redirect: (e) => ({
      name: "request",
      params: { ...e.params, request: "default" }
    }),
    children: [
      {
        name: "request",
        path: "request/:request",
        component: () => import("./views/Request/Request.vue.js")
      },
      {
        name: "request.examples",
        path: "request/:request/examples/:examples",
        component: () => import("./views/Request/Request.vue.js")
      },
      {
        name: "collection",
        path: "collection/:collection",
        component: () => import("./views/Collection/Collection.vue.js"),
        redirect: () => ({
          name: "collection.overview"
        }),
        children: [
          {
            name: "collection.overview",
            path: "overview",
            component: () => import("./views/Collection/CollectionOverview.vue.js")
          },
          {
            name: "collection.servers",
            path: "servers",
            component: () => import("./views/Collection/CollectionServers.vue.js"),
            children: [
              {
                name: "collection.servers.edit",
                path: ":servers",
                component: () => import("./views/Collection/CollectionServers.vue.js")
              }
            ]
          },
          {
            name: "collection.environment",
            path: "environment",
            component: () => import("./views/Collection/CollectionEnvironment.vue.js")
          },
          {
            name: "collection.authentication",
            path: "authentication",
            component: () => import("./views/Collection/CollectionAuthentication.vue.js")
          },
          {
            name: "collection.cookies",
            path: "cookies",
            component: () => import("./views/Collection/CollectionCookies.vue.js")
          },
          {
            name: "collection.scripts",
            path: "scripts",
            component: () => import("./views/Collection/CollectionScripts.vue.js")
          },
          {
            name: "collection.sync",
            path: "sync",
            component: () => import("./views/Collection/CollectionSync.vue.js")
          },
          {
            name: "collection.settings",
            path: "settings",
            component: () => import("./views/Collection/CollectionSettings.vue.js")
          }
        ]
      }
    ]
  }
], c = [
  {
    name: "root",
    path: "/",
    redirect: n
  },
  {
    name: "workspace.default",
    path: "/workspace",
    redirect: {
      name: "workspace",
      params: {
        workspace: "default"
      }
    }
  },
  {
    name: "workspace",
    path: "/workspace/:workspace",
    redirect: {
      name: "request.root"
    },
    children: r
  }
], m = [
  {
    name: "root",
    path: "/",
    redirect: n
  },
  {
    name: "workspace.default",
    path: "/workspace",
    redirect: {
      name: "request.root",
      params: {
        workspace: "default"
      }
    }
  },
  {
    name: "workspace",
    path: "/workspace/:workspace",
    redirect: {
      name: "request.root"
    },
    children: [
      ...r,
      {
        name: "environment.default",
        path: "environment",
        redirect: (e) => ({
          name: "environment",
          params: { ...e.params, environment: "default" }
        })
      },
      {
        name: "environment",
        path: "environment/:environment",
        component: () => import("./views/Environment/Environment.vue.js")
      },
      {
        name: "environment.collection",
        path: "environment/:collection/:environment",
        component: () => import("./views/Environment/Environment.vue.js"),
        props: !0
      },
      {
        name: "cookies.default",
        path: "cookies",
        redirect: (e) => ({
          name: "cookies",
          params: { ...e.params, cookies: "default" }
        })
      },
      {
        name: "cookies",
        path: "cookies/:cookies",
        component: () => import("./views/Cookies/Cookies.vue.js")
      },
      {
        name: "servers.default",
        path: "servers",
        redirect: (e) => ({
          name: "servers",
          params: {
            ...e.params,
            collection: "default",
            servers: "default"
          }
        })
      },
      {
        name: "settings.default",
        path: "settings",
        redirect: (e) => ({
          name: "settings",
          params: { ...e.params, settings: "general" }
        })
      },
      {
        name: "settings",
        path: "settings/:settings",
        component: () => import("./views/Settings/Settings.vue.js")
      }
    ]
  }
];
export {
  a as PathId,
  c as modalRoutes,
  n as redirectToActiveWorkspace,
  m as routes,
  s as saveActiveWorkspace
};
